<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 用户管理 / 用户列表 / 注册用户</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>登录账号
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="account" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>登录密码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="pwd" type="password" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>支付密码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="payPwd" type="password" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>昵称
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="nickName" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>手机号码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="phone" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>邮箱
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="email" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>真实姓名
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="name" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>身份证号码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="card" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>会员等级
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="level" class="boxText">
                <option :key="index" v-for="(value,index) in levelList" :value="value.levelId">{{value.levelName}}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>团队等级
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="teamLevel" class="boxText">
                <option :key="index" v-for="(value,index) in teamLevelList" :value="value.levelId">{{value.levelName}}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>会员类型
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select v-model="userType" class="boxText">
                <option value="0">会员</option>
                <option value="1">业务员</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>推荐人ID
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="recommender" class="boxText"/>
            </td>
          </tr>
        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="添加" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "AddUser",
  data(){
    return{
      account:"",
      pwd:"",
      payPwd:"",
      name:"",
      nickName:"",
      phone:"",
      email:"",
      card:"",
      level:0,
      teamLevel:0,
      recommender:"",
      userType:1,
      levelList:[],
      teamLevelList:[]
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    axiosGet(DO_NET_URL+"api/GetLevel",function (res){
      console.log(res.data)
      that.levelList=res.data
      if(that.levelList.length>0){
        that.level=that.levelList[0].levelId
      }
    })
    axiosGet(DO_NET_URL+"teamLevel/GetLevel",function (res){
      console.log(res.data)
      that.teamLevelList=res.data
      if(that.teamLevelList.length>0){
        that.teamLevel=that.teamLevelList[0].levelId
      }
    })
  },
  methods: {
    addAdmin(){
      let that=this
      if(this.account==""){
        toask("请输入登录账号！",6)
        return
      }
      if(this.pwd==""){
        toask("请输入登录密码！",6)
        return;
      }
      if(this.payPwd==""){
        toask("请输入支付密码！",6)
        return;
      }
      if(this.name==""){
        toask("请输入真实姓名！",6)
        return;
      }
      if(this.nickName==""){
        toask("请输入昵称！",6)
        return;
      }
      if(this.phone==""){
        toask("请输入手机号码！",6)
        return;
      }
      if(this.email==""){
        toask("请输入邮箱！",6)
        return;
      }
      if(this.card==""){
        toask("请输入身份证号码！",6)
        return;
      }
      if(this.recommender==""){
        toask("请输入推荐人ID！",6)
        return;
      }
      loading("请求中")
      axiosPost(DO_NET_URL+"user/AddUserByBg?email="+this.email+"&account="+this.account+"&pwd="+this.pwd+"&payPwd="+this.payPwd+"&name="+this.name+"&nickName="+this.nickName+"&phone="+this.phone+"&card="+this.card+"&level="+this.level+"&teamLevel="+this.teamLevel+"&recommender="+this.recommender+"&userType="+this.userType,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("注册成功",6)
          setTimeout(function (){
            that.$emit("send",'userList')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'userList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>